import {gql} from 'apollo-boost';
import {TEACHER_NAME_FIELDS} from '@/queries/fragments/name-fields';

export const GET_VDOSETS_BY_FILTER = gql`

  query getVdoSetsByFilter($vdoSetFilterInput: VdoSetFilterInput){
    getVdoSetsByFilter (
      vdoSetFilterInput:$vdoSetFilterInput
      # รับข้อมูลตามนี้จะใส่หรือไม่ใส่ก็ได้
      #  input VdoSetFilterInput {
      #    courseOutlineId: ID
      #    degreeId: ID
      #    subjectGroupId: ID
      #    subjectId: ID
      #    subjectCode: String
      #    teacherId: ID
      #    teacherCode: String
      #    code: String
      #  }
    ){
      id
      degree {
        id code nameLocal nameEng
      }
      courseOutline{
        id
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      subject{
        id code nameLocal nameEng
      }
      subjectCode
      teacher {
        ...TeacherNameFields
        picturePath
      }
      teacherCode
      code
      description
      totalVdoLength
      vdoSetUnits {
        id
        vdoSetTopics{
          id vdoStreamPath
          playbackUrl
          playbackStatus
          videoProvider
          bunnyVideoGuid
          bunnyStatus
        }
      }

      label
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const GET_VDOSETS = gql`
  query getVdoSets {
    getVdoSets {
      id
      degree {
        id code nameLocal nameEng
      }
      courseOutline{
        id
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      subject{
        id code nameLocal nameEng
      }
      subjectCode
      teacher {
        ...TeacherNameFields
        picturePath
      }
      teacherCode
      code
      description
      totalVdoLength

      label
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const GET_VDOSET = gql`
  query getVdoSet($id : ID!){
    getVdoSet (
      id: $id
    ) {
      id
      degree {
        id code nameLocal nameEng
      }
      courseOutline{
        id
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      subject{
        id code nameLocal nameEng
      }
      subjectCode
      teacher {
        ...TeacherNameFields
        picturePath
      }
      teacherCode
      code
      description
      totalVdoLength
      vdoSetUnits {
        id unitSeq code
        courseOutlineUnit {
          id seq
        }
        teacher {
          ...TeacherNameFields
          picturePath
        }
        unitSeq
        code
        totalVdoLength
        status
        remark
        vdoSetTopics{
          id no nameLocal nameEng vdoStreamPath isEnabled
          playbackUrl
          playbackStatus
          videoProvider
          bunnyVideoGuid
          bunnyStatus
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const ADD_VDOSET = gql`
  mutation addVdoSet(
    $degreeId: ID!,
    $courseOutlineId: ID!,
    $subjectGroupId: ID!,
    $subjectId: ID!,
    $teacherId: ID!,
    $vdoSetInput: VdoSetInput!
  ) {
    addVdoSet(
      degreeId: $degreeId
      courseOutlineId: $courseOutlineId
      subjectGroupId: $subjectGroupId
      subjectId: $subjectId
      teacherId: $teacherId
      vdoSetInput: $vdoSetInput
    ) {
      id
      degree {
        id code nameLocal nameEng
      }
      courseOutline{
        id
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      subject{
        id code nameLocal nameEng
      }
      subjectCode
      teacher {
        ...TeacherNameFields
        picturePath
      }
      teacherCode
      code
      description
      totalVdoLength
      vdoSetUnits {
        id unitSeq code
        courseOutlineUnit{ id nameLocal nameEng}
        teacher {
          ...TeacherNameFields
          picturePath
        }
        unitSeq
        code
        totalVdoLength
        status
        remark
        vdoSetTopics{
          id no nameLocal nameEng vdoStreamPath isEnabled
          playbackUrl
          playbackStatus
          videoProvider
          bunnyVideoGuid
          bunnyStatus
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const UPDATE_VDOSET = gql`
  mutation updateVdoSet(
    $id: ID!,
    $code: String
    $description: String
  ) {
    updateVdoSet(
      id: $id
      code: $code
      description: $description
    ) {
      id
      degree {
        id code nameLocal nameEng
      }
      courseOutline{
        id
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      subject{
        id code nameLocal nameEng
      }
      subjectCode
      teacher {
        ...TeacherNameFields
        picturePath
      }
      teacherCode
      code
      description
      totalVdoLength
      vdoSetUnits {
        id unitSeq code
        courseOutlineUnit{ id nameLocal nameEng}
        teacher {
          ...TeacherNameFields
          picturePath
        }
        unitSeq
        code
        totalVdoLength
        status
        remark
        vdoSetTopics{
          id no nameLocal nameEng vdoStreamPath isEnabled
          playbackUrl
          playbackStatus
          videoProvider
          bunnyVideoGuid
          bunnyStatus
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const DELETE_VDOSET = gql`
  mutation deleteVdoSet($id: ID!) {
    deleteVdoSet(
      id: $id
    ) {
      id
      degree {
        id code nameLocal nameEng
      }
      courseOutline{
        id
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      subject{
        id code nameLocal nameEng
      }
      subjectCode
      teacher {
        ...TeacherNameFields
        picturePath
      }
      teacherCode
      code
      description
      totalVdoLength
      vdoSetUnits {
        id unitSeq code
        courseOutlineUnit {
          id seq
        }
        teacher {
          ...TeacherNameFields
          picturePath
        }
        unitSeq
        code
        totalVdoLength
        status
        remark
        vdoSetTopics{
          id no nameLocal nameEng vdoStreamPath isEnabled
          playbackUrl
          playbackStatus
          videoProvider
          bunnyVideoGuid
          bunnyStatus
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

